import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable } from 'rxjs';

@Component({
  selector: 'loading-or-error',
  templateUrl: './loading-or-error.component.html',
  styleUrls: ['./loading-or-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, CommonModule, MatProgressSpinnerModule]
})
export class LoadingOrErrorComponent {
  /**
   * Observable to subscribe to
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error$ = input<Observable<any> | undefined>(undefined);

  /**
   * Text message to display when error occurs
   */
  errorMessage = input<string>(`Une erreur s'est produite.`);

  /**
   * Retry Button text
   */
  retryMessage = input<string>('réessayer');

  /**
   * Use icon only when error occurs
   */
  useIconOnly = input<boolean>(true);

  /**
   * Display shimmer placeholder while loading
   */
  useShimmer = input<boolean>(false);

  shimmerVariant = input<'default' | 'wide'>('default');

  color = input<'primary' | 'accent' | 'warn' | undefined>(undefined);

  loaderSize = input<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'>('xs');
  retry = output<void>();

  retryLoad(): void {
    this.retry.emit();
  }
}
